import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/articles';

export default function ArticlesSection() {
  return (
    <section className="relative py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="mb-12 md:mb-16">
          <p className="text-xs md:text-sm font-medium text-foreground-500 uppercase tracking-widest mb-3">
            Latest Guides & Articles
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Expert <span className="italic text-primary-500">Kakobuy Spreadsheet</span> Resources
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl">
            Dive deep into our collection of in-depth guides covering everything from safety tips and beginner strategies to category-specific shopping advice.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {allArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/articles/${article.slug}`}
              className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/60 card-hover cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] bg-background-100 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-700 text-[11px] font-semibold whitespace-nowrap">
                  {article.readingTime}
                </div>
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-2 text-xs text-foreground-400 mb-2">
                  <i className="ri-calendar-line"></i>
                  <span>{article.lastUpdated}</span>
                </div>
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.metaDescription}
                </p>
                <div className="mt-4 flex items-center gap-1.5 text-sm font-semibold text-primary-600 group-hover:gap-2 transition-all">
                  <span className="whitespace-nowrap">Read Article</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/articles/kakobuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-primary-500 text-primary-600 font-semibold text-sm hover:bg-primary-50 transition-all whitespace-nowrap"
          >
            <i className="ri-book-read-line"></i>
            Browse All Guides
          </Link>
        </div>
      </div>
    </section>
  );
}